import React from 'react';
import {
  StatusAlertFilledSmall,
  StatusWarningFilledSmall,
} from '@wix/wix-ui-icons-common';

import { Text } from '../../../Text';
import { dataHooks } from '../../constants';
import {
  FieldSetProps,
  LegendPlacement,
  LegendSize,
  FieldSetStatusType,
} from '../../FieldSet.types';

import { st, classes } from './StatusMessage.st.css';

const StatusIcon = ({ status }: { status: FieldSetStatusType }) => {
  const iconByStatus = {
    error: StatusAlertFilledSmall,
    warning: StatusWarningFilledSmall,
  };
  const Icon = iconByStatus[status];

  return (
    <div className={classes.statusIcon}>
      <Icon />
    </div>
  );
};

const StatusMessage = ({
  statusMessage,
  status,
  labelSize,
  labelPlacement,
  statusId,
}: Pick<FieldSetProps, 'statusMessage' | 'status' | 'statusId'> & {
  labelSize: LegendSize;
  labelPlacement: LegendPlacement;
}) => (
  <div
    className={st(classes.root, {
      status,
      labelSize,
      labelPlacement,
    })}
  >
    {status && <StatusIcon status={status} />}
    <Text
      id={statusId}
      dataHook={dataHooks.statusMessage}
      skin={status === 'error' ? 'error' : 'standard'}
      secondary={status !== 'error'}
      size={labelSize}
    >
      {statusMessage}
    </Text>
  </div>
);

export { StatusMessage };
